import createAction from 'Store/utils/createAction';
import {
  SET_ADULTS,
  SET_ATTENDEES,
  TRIP_INFORMATION_SET_ADULTS_NUMBER,
  TRIP_INFORMATION_UPDATE_ADULT,
} from './constants';

function setAdultsNumber(adultsNumber: number | null | undefined): SetAdultsAction {
  return createAction(TRIP_INFORMATION_SET_ADULTS_NUMBER, {
    adultsNumber,
  });
}

function updateAdult(index: number, valuesToUpdate: UpdateAdultPayload): UpdateAdultAction {
  return createAction(TRIP_INFORMATION_UPDATE_ADULT, {
    index,
    valuesToUpdate,
  });
}

function setAttendees(payload: any) {
  return createAction(SET_ATTENDEES, payload);
}

function setAdults(payload: any) {
  return createAction(SET_ADULTS, payload);
}

export { setAdultsNumber, updateAdult, setAttendees, setAdults };
